export var trackingAttributes = function (trackingCat, trackingId) { return [trackingCat, trackingId]; };
